// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// ...

// —————————————————————————————————————— API METHOD DEF. ——————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function manageSections(action, selector_sect = null, opts = {}) {
  ////////////// Setup ///////////////
  ////////////////////////////////////

  const { sections: sects } = this.ref;
  const inst_fP = window.fullpage_api;

  if (!inst_fP) {
    console.warn("Fullpage.js instance not found");
    return false;
  }

  ///////// Helper Functions /////////
  ////////////////////////////////////

  const findSection = (selector) => {
    if (typeof selector === "string") return sects.find((s) => s.dataset.anchor === selector); // Find by anchor
    if (typeof selector === "number") return sects[selector]; // Find by index
    if (selector instanceof HTMLElement) return selector; // Find by element
    console.warn(`Section not found: ${selector}`);
    return null;
  };

  const isCurrentSection = (sect) => {
    const inst_fP = window.fullpage_api;
    if (!inst_fP) return false;
    const activeSection = inst_fP.getActiveSection();
    return activeSection && activeSection.item === sect;
  };

  const navigateToNextVisibleSection = (currentSection) => {
    const currentIndex = sects.indexOf(currentSection);

    // Try next section first
    for (let i = currentIndex + 1; i < sects.length; i++) {
      if (sects[i].dataset.hiddenFull !== "true") {
        window.fullpage_api.moveTo(sects[i].dataset.anchor);
        return;
      }
    }

    // Try previous sections
    for (let i = currentIndex - 1; i >= 0; i--) {
      if (sects[i].dataset.hiddenFull !== "true") {
        window.fullpage_api.moveTo(sects[i].dataset.anchor);
        return;
      }
    }
  };

  const rebuildFullpage = () => {
    const inst_fP = window.fullpage_api;
    if (!inst_fP) return false;

    // // Try using reBuild method first (less disruptive)
    // if (typeof inst_fP.reBuild === "function") {
    //   inst_fP.reBuild();
    //   return true;
    // }

    // Fallback to destroy/rebuild with position preservation
    // Store current section before destroying
    const currentSection = inst_fP.getActiveSection();
    const currentAnchor = currentSection ? currentSection.anchor : null;

    inst_fP.destroy("all");

    setTimeout(() => {
      this.init_fullpage();

      // Restore position to current section if it's still visible
      if (currentAnchor) {
        const targetSection = sects.find((s) => s.dataset.anchor === currentAnchor);
        if (targetSection && targetSection.dataset.hiddenFull !== "true") {
          setTimeout(() => {
            if (window.fullpage_api && typeof window.fullpage_api.silentMoveTo === "function") {
              window.fullpage_api.silentMoveTo(currentAnchor);
            } else if (window.fullpage_api && typeof window.fullpage_api.moveTo === "function") {
              window.fullpage_api.moveTo(currentAnchor);
            }
          }, 100);
        }
      }
    }, 50);

    return true;
  };

  const hideSection = (selector, opts = {}) => {
    const section = findSection(selector);
    if (!section) return false;
    section.dataset.hiddenFull = "true"; // Set hidden attribute
    section.classList.add("section--hidden"); // Add CSS class for styling
    if (opts.rebuild !== false) rebuildFullpage(); // Rebuild fullpage if needed
    if (opts.navigateAway && isCurrentSection(section)) navigateToNextVisibleSection(section); // Navigate away if currently on this section
    return true;
  };

  const showSection = (selector, opts = {}) => {
    const section = findSection(selector);
    if (!section) return false;
    section.dataset.hiddenFull = "false"; // Remove hidden-full attribute
    section.classList.remove("section--hidden"); // Remove CSS class for styling
    if (opts.rebuild !== false) rebuildFullpage(); // Rebuild fullpage if needed
    return true;
  };

  const toggleSection = (selector, opts = {}) => {
    const section = findSection(selector);
    if (!section) return false;
    const isHidden = section.dataset.hiddenFull === "true";
    return isHidden ? showSection(selector, opts) : hideSection(selector, opts);
  };

  const hideSections = (selector, opts = {}) => {
    if (!Array.isArray(selector)) return false;
    const results = selector.map((id) => hideSection(id, { ...opts, rebuild: false }));
    if (opts.rebuild !== false) rebuildFullpage(); // Re-init.
    return results.every((result) => result === true);
  };

  const showSections = (selector, opts = {}) => {
    if (!Array.isArray(selector)) return false;
    const results = selector.map((id) => showSection(id, { ...opts, rebuild: false }));
    if (opts.rebuild !== false) rebuildFullpage(); // Re-init.
    return results.every((result) => result === true);
  };

  const hideByChapter = (chapter, opts = {}) => {
    const sects_chapter = sects.filter((s) => s.dataset.chapter === chapter);
    console.warn(`Hiding sections for chapter: ${chapter}`, sects_chapter);
    sects_chapter.forEach((s) => {
      s.dataset.hiddenFull = "true";
      s.classList.add("section--hidden");
    });
    if (opts.rebuild !== false) rebuildFullpage(); // Re-init.
    return sects_chapter.length > 0;
  };

  const showByChapter = (chapter, opts = {}) => {
    const sects_chapter = sects.filter((s) => s.dataset.chapter === chapter);
    console.warn(`Showing sections for chapter: ${chapter}`, sects_chapter);
    sects_chapter.forEach((s) => {
      s.dataset.hiddenFull = "false";
      s.classList.remove("section--hidden");
    });
    if (opts.rebuild !== false) rebuildFullpage(); // Re-init.
    return sects_chapter.length > 0;
  };

  ///////////// Actions //////////////
  ////////////////////////////////////

  switch (action) {
    case "hide":
      return hideSection(selector_sect, opts);

    case "show":
      return showSection(selector_sect, opts);

    case "toggle":
      return toggleSection(selector_sect, opts);

    case "hideMultiple":
      return hideSections(selector_sect, opts); // expects array

    case "showMultiple":
      return showSections(selector_sect, opts); // expects array

    case "hideByChapter":
      return hideByChapter(selector_sect, opts);

    case "showByChapter":
      return showByChapter(selector_sect, opts);

    case "rebuild":
      return rebuildFullpage(opts);

    default:
      console.warn(`Unknown section management action: ${action}`);
      return false;
  }
}
